var _path, _g, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-tc",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002868",
    d: "M640 480V0H0v480h640z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    strokeWidth: 8,
    d: "M590 174.6v90c0 60-30 124.6-105 159.6-75-35-105-99.6-105-159.6v-90z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 7,
    d: "M590 174.6v90c0 60-30 124.6-105 159.6-75-35-105-99.6-105-159.6v-90z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcad56",
    strokeWidth: 0.275,
    d: "M447.1 273.7c-2.7 4.7-7.4 5.7-11 4.2-3.7-1.5-7.1-10.3-10.9-15-3.6-4.7-4.6-2.7-7-5.4a37.6 37.6 0 0 0-12-7.4c-3.3-1.5-6.7-2.9-9-8.6a9.8 9.8 0 0 1 5.2-5.1c1.9-.7 3.4-3.4 3.6-5.8.3-2.2 2.3-4.7 5-6.6-1.3.2-3.9-.3-5.1-1.1-1.1-1-3-.8-4.1 0-1.2.8-2.6 1-4.6.8.8-.6 2.2-2 2.3-3.2s1.6-1.9 4.5-1.9c2.8 0 4.6-3.2 6.9-3.2-1.6 0-1.3-2.8-.4-3-4-.7-3.5-4-1.9-4-.1-.4-.6-1-2.5-1.5-1.7-.7-.9-2.3.5-3.3-1.2-2.5-.1-4.4 1.9-6-2.8-.1.3-4 1-6.1.8-2 1.1-2.3 2-1 1 1.1 3.3 3.7 5.9 4.5 2.5.7 4 2.1 4.5 4.2.5 2.3 1.5 3.4 4.2 4.4 2.9.9 6.8 3.3 6.3 8.6 2.2.2 3.9.8 5.2 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa1a1",
    strokeWidth: 0.275,
    d: "M454 206a8 8 0 0 0 3.1 6.4c1.9 1.5 3.5 2.7 3.1 4.6-.3 2 .4 3.2 2 4.5 1.8 1.2 3 2.7 2.6 5.2s-.2 4 .8 5.9 2.8 3.4 2 6.4-.4 7 .6 9c1 1.9 0 3.4-1.7 6.7-1.8 3.3-2.8 4.5-6.4 5.8-3.7 1.1-4 3.4-4 7.2 0 4-2.6 6-7.5 5.3-5 4.1-8.1-.8-9.4-6.9s-1.4-12.8-8.8-18.1c-7.3-5.5-4.4-14.8 1.7-18.5 6.1-3.6 5.4-14.4 4.6-21-.6-6.6 3.8-10.4 7.2-14 4.5 1.7 10.1 8.6 10.1 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b2dc",
    strokeWidth: 0.275,
    d: "M443.4 248.6c-1.4-3.2-2.9-6.5.7-13.5 3.8-7.1 1.4-12.5.3-16.1-1.1-3.5-1.4-6.8 0-8.3 1.5-1.3 2.1-2.2 2.2-4.6.1-2.2 2-1.5 2.3-.4s.5 3-1.5 6.4c-2 3.5 5.6 12 2.1 21.1-2.4 6.4.8 14.5 2 20.2s2 19-6.3 21c5.7-2.7.4-20.5-1.8-25.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.275,
    d: "M406.3 247.6c1.3.3 2-.5 2.4-1.4s.7-1.3 2-1.5c1.2 0 3.2-.3 3.7-1.3.4-1 1.9-.2 3.2-2.7 1.3-2.6 2.1-5.6 5.5-6.7m9.3-21.8c-1.3 0-4.9.2-6.4 3.4m-10.4-18.9c3 .9 1.8 2.9 3.3 4 2.7 2.2.2 4.4 2.5 5s2.1 1 1.6 3.5c-.8 2.9 2 3 1 4.9m-13 9.9c1.8-1.6 6.1-2.9 7.1-4.6m-7.2-4c2.6-.2 6.1.8 6.6-.2m-7-2.7c1.3 0 3.9-.9 4.4-2.6m-6.3-1.4c1.5 0 3.4-.1 5.3-1.5m-7.3-3.4c1.1-.9 3.1.1 5-1.1m-3.1-4.9c.9 0 2.8-.2 2.8.9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9e540a",
    transform: "matrix(.125 0 0 .125 535 249.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-55-233s-70-59-128-99-128-89-128-99c11-8 70 30 151 79 82 50 128 99 128 99zm-5 40s-68-41-135-70c-70-29-175-29-186-39 0-10 122-16 209 19 89 41 135 70 135 70zm-1 68s-74-34-146-50c-70-16-170-10-182-19 0-10 124-30 217 0 94 29 134 49 134 49zm-4 69s-56-38-130-46c-70-7-163 46-175 36 0-10 81-69 182-59 99 10 146 49 146 49zm23-218s-71-65-71-109c0-39 43-99 62-99-10 20-43 60-43 99 0 40 75 89 75 89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42-274s14-65 14-109c0-59-42-113-38-128 15 15 57 59 57 128 0 60-10 89-10 89z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    stroke: "#fcd116",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-25-295c0-19-7-36-19-49-16-19-40-25-65-21-30 5-54 23-69 51-20 37-22 77-23 116 0 135 5 190 9 323 1 39 8 119-10 182-7 27-15 52-27 78 8-33 12-50 16-75 11-65 8-126 6-186-4-123-11-186-15-335-1-45 3-79 24-115 22-37 60-64 103-64 18 0 33 3 48 12 30 16 44 49 44 82z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-19 187s-28 50-49 86-38 44-54 33c-15-11-2-40 10-54s79-79 79-79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12 191s-11 57-20 98c-8 41-22 55-39 50-18-4-15-37-8-54s49-103 49-103z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 193v100c0 42-10 59-29 58-18-1-22-33-18-52 3-18 28-111 28-111z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 192c-53-1-58-20-58-20s-7-24-8-39c-1-2-15-32-11-45-5-12-17-41-6-46-5-14-13-30-14-45-4-11-14-35-6-43 0 0-19-40-10-50 0 0-9-39 0-49 0 0 0-40 10-50 0 0 0-39 9-49 0 2 28-55 94-55l-1 85h1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-26c-85-1-103-20-103-20M0-76c-85 0-113-20-113-20M0-125c-85-1-113-20-113-20M0-175c-85-1-103-20-103-20m102-19c1 0-64 0-74-10l-19-19M0 152c-25 0-53-4-66-19m66-21c-47 0-75-19-75-19s-1-2-2-5M0 63c-62-1-79-14-83-21M0 23C-85 23-94 3-94 3l-3-6"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.125 0 0 .125 485 299.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009e49",
    d: "M0 712c-43 40-126 14-152-4-27 9-99-19-118-50-52 7-70-67-61-86 14-28-11-46 7-65 25-24-14-47 10-63 24-17-6-45 18-63 25-19-13-45 13-58s-3-47 19-60-13-46 17-61c29-15 3-41 26-52 25-13 2-40 25-49 26-11 7-40 29-48 19-7 7-25 19-41H0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-99 18c-20 20 4 35-16 59-21 25-2 38-19 60s8 33-11 58c-19 24 4 39-17 59-20 21 4 39-17 61-20 23 4 38-16 58-21 21 3 43-17 63-20 21 4 47-19 71-22 24 4 43-14 61-19 19-2 38-15 51s-15 31-10 39M-60 25c-18 25 10 36-7 56-17 21 7 28-6 52s10 30-7 54 9 43-9 67c-19 24 9 37-8 61-16 25 8 38-7 56-15 19 11 37-8 60-18 22 8 39-7 59-15 21 6 43-7 60-13 16 9 41-10 63-18 22 4 37-7 52s-20 37-9 43"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#009e49",
    d: "M0 712V12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 48c-9 39 13 73 0 106-13 32 9 45 2 71-8 26 9 45-2 73s15 50 0 87c-15 36 10 45 0 82-11 42 19 64 0 94s17 37 2 71c-15 33 9 46-2 80"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M15 174c-5 11 15 37 4 57-12 19 6 49-6 73s19 54 7 82c-13 28 6 63 0 89-5 26 13 76 0 94-13 19 13 24-2 70s-25 7-16-7c19-31-21-41-2-71s-11-52 0-94c10-37-15-46 0-82 15-37-11-59 0-87s-6-47 2-73c7-26-15-39-2-71 10-32 20 9 15 20zm-84 32c-7 12 12 35-5 58-12 16 8 35-9 58-11 16 11 36-4 59-10 13 7 38-5 57-12 20 6 36-15 62-12 14 9 49-4 60s-1 54-10 60c-8 7 0 38-22 45 11-15-11-30 7-52 19-22-3-47 10-63 13-17-8-39 7-60 15-20-11-37 7-59 19-23-7-41 8-60 15-18-9-31 7-56 17-24-11-37 8-61 18-24-8-43 9-67s-6-30 7-54c24 9 12 61 4 73zm-50-65c-10 16 4 35-11 55-15 21 0 47-15 64-15 16 4 48-15 61s-7 52-22 65 0 50-17 69-9 58-19 67c-9 9 13 28-3 41-17 13-17 39-39 56 13-13-4-32 15-51 18-18-8-37 14-61 23-24-1-50 19-71 20-20-4-42 17-63 20-20-4-35 16-58 21-22-3-40 17-61 21-20-2-35 17-59 19-25-6-36 11-58 8-10 8-19 8-27 12-31 12 23 7 31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M-139 35c0-210 29-283 139-283s139 73 139 283z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-139 35c0-210 29-283 139-283-50 0-81 39-89 65-9 26-4 24 7 14s6 12-4 24c-9 12-18 47-5 36 13-12 23 1 9 21-14 19-26 65-12 49s17 10 8 23c-8 13-7 25 0 19 8-6 7 21 0 32zm191-4C52 0 53-73 36-97c-12-19-12-39 2-17s21 11 11-11c-12-28-28-59-24-65 5-7 8-4 18 11s12-7 1-22c-11-14-10-17 13-7 41 17 61 66 61 231z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 65c-44 0-92-7-124-20-38-15-40-28-27-44 10-12 30-5 50 4 19 8 73 14 101 14s82-6 101-15c20-8 40-15 50-3 13 16 11 29-27 44C92 58 44 65 0 65Z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h320v240H0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 96.5v48h320v-48zM136.5 0v240h48V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTc);
export default __webpack_public_path__ + "static/media/tc.e8dd367f8c40a4f1ea9156556fd6ce3f.svg";
export { ForwardRef as ReactComponent };